import React, { useState, useEffect } from "react";
import "./Product.css";
import { connect } from "react-redux";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import ListingPagination from "../Pagination/ListingPagination";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import {
  selectAllCategoryProducts,
  setAges,
  setBrakeTypes,
  setBrands,
  setFrameMaterials,
  setHeights,
  setMaterials,
  setSelectedCategoryID,
  setWheelSizes,
} from "../../../features/listingPage/listingPageSlice";
import {
  fetchAllWishlistsAsync,
  addToWishlistsAsync,
  removeFromWishlistAsync,
  selectAllWishlists,
} from "../../../features/wishlist/wishlistSlice";
import { fetchAllCartsAsync } from "../../../features/cartPage/cartPageSlice";
import { selectUser } from "../../../features/auth/authSlice";
import StarIcon from "@mui/icons-material/Star";
import {
  toggleOverlay,
  selectIsOverlayVisible,
} from "../../../store/slices/headerSlice";
import HoverSlider from "../ListingProduct/HoverSlider";
import SelectDesktopVariant from "../../EndPages/SelectDesktopVariant";
import { selectAllFilter } from "../../../store/slices/allFilterSlice";
import { setBreadcrumb } from "../../../store/slices/breadCrumbsSlice";
import NoProductFound from "../ListingProduct/NoProductFound";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import cartOutlineLogo from "../../../img/navigation/cart-bookmark-outline.png";
import cartFilledLogo from "../../../img/navigation/cart-bookmark-filled.png";
import {
  calculateDealerPrice,
  calculateUpdatedDiscountPercentage,
  formatWithCommasWithDecimal,
} from "../../../utils/utils";
import { trackEvent } from "../../../analytics/gtag";
import { EVENTS } from "../../../analytics/events";

function Product({
  isOverlayVisible,
  toggleOverlay,
  currentPage,
  setCurrentPage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pdts = useSelector(selectAllCategoryProducts);
  const products = pdts?.Data;
  const qtys = pdts?.quantity;

  const wishlist = useSelector(selectAllWishlists);
  const userDetail = useSelector(selectUser);
  const [openDesktopVariant, setOpenDesktopVariant] = useState(null);
  const [items, setItems] = useState(products?.product || []);
  const [currentItems, setCurrentItems] = useState([]);

  const itemsPerPage = 15;
  const allfilter = useSelector(selectAllFilter);
  const { CategoryID, categoryName } = useParams();
  const [open, setOpen] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (userDetail.UserID) {
      dispatch(fetchAllWishlistsAsync(userDetail?.UserID));
      dispatch(fetchAllCartsAsync(userDetail?.UserID));
    }
  }, [dispatch, userDetail?.UserID]);

  // set selectedCategory id
  useEffect(() => {
    if (CategoryID) {
      dispatch(setSelectedCategoryID(CategoryID));
    }

    // Set all Brands of respective category,subCategory
    if (products?.manufacture_name && products?.manufacture_name) {
      dispatch(
        setBrands(products?.manufacture_name && products?.manufacture_name)
      );
    }
    if (products?.material && products?.material) {
      dispatch(setMaterials(products?.material && products?.material));
    }
    if (
      products?.descriptions?.Age &&
      products?.descriptions?.Age?.length > 0
    ) {
      dispatch(
        setAges(products?.descriptions?.Age && products?.descriptions?.Age)
      );
    }
    if (
      products?.descriptions?.Front &&
      products?.descriptions?.Front?.length > 0
    ) {
      dispatch(
        setBrakeTypes(
          products?.descriptions?.Front && products?.descriptions?.Front
        )
      );
    }
    if (
      products?.descriptions?.Wheel &&
      products?.descriptions?.Wheel?.length > 0
    ) {
      dispatch(
        setWheelSizes(
          products?.descriptions?.Wheel && products?.descriptions?.Wheel
        )
      );
    }
    if (
      products?.descriptions?.Height &&
      products?.descriptions?.Height?.length > 0
    ) {
      dispatch(
        setHeights(
          products?.descriptions?.Height && products?.descriptions?.Height
        )
      );
    }
    if (
      products?.descriptions?.["Frame Material"] &&
      products?.descriptions?.["Frame Material"]?.length > 0
    ) {
      dispatch(
        setFrameMaterials(
          products?.descriptions?.["Frame Material"] &&
            products?.descriptions?.["Frame Material"]
        )
      );
    }

    // Update breadcrumb
    dispatch(
      setBreadcrumb({
        categoryID: CategoryID,
        categoryName: categoryName,
        // subCategoryID: null,
        subCategoryName: null,
        ProductID: null,
        productName: "",
      })
    );
  }, [
    dispatch,
    CategoryID,
    categoryName,
    products?.manufacture_name,
    products?.material,
    products?.descriptions,
  ]);

  useEffect(() => {
    if (
      products &&
      products?.product &&
      Array?.isArray(allfilter?.brands) &&
      Array?.isArray(allfilter?.materials)
    ) {
      const filteredItems = products?.product?.filter((product) => {
        const brandFilterPassed =
          allfilter?.brands?.length === 0 ||
          allfilter?.brands?.includes(product?.manufacture_name);
        const outOfStockFilterPassed =
          allfilter?.outOfStock === true || !isOutOfStock(product?.prod_ID);
        const materialFilterPassed =
          allfilter?.materials?.length === 0 ||
          allfilter?.materials?.includes(product?.material_name);
        const ageFilterPassed =
          allfilter?.age?.length === 0 ||
          allfilter?.age?.includes(product?.descriptions?.Age);
        const heightFilterPassed =
          allfilter?.height?.length === 0 ||
          allfilter?.height?.includes(product?.descriptions?.Height);
        const frameMaterialFilterPassed =
          allfilter?.frameMaterial?.length === 0 ||
          allfilter?.frameMaterial?.includes(
            product?.descriptions?.["Frame Material"]
          );
        const wheelSizeFilterPassed =
          allfilter?.wheelSize?.length === 0 ||
          allfilter?.wheelSize?.includes(product?.descriptions?.Wheel);
        const brakeTypeFilterPassed =
          allfilter?.brakeType?.length === 0 ||
          allfilter?.brakeType?.includes(product?.descriptions?.Front);
        const shippingFilterPassed =
          !allfilter?.shipping ||
          allfilter?.shipping === "standard" ||
          allfilter?.shipping?.includes(product?.shipping);
        const ratingFilterPassed =
          allfilter?.rating === 0 ||
          parseInt(product?.net_rating) >= parseInt(allfilter?.rating);
        const dealerMarginFilterPassed =
          allfilter?.dealerMargin === 0 ||
          parseInt(
            calculateUpdatedDiscountPercentage(
              product?.skuDetails[0]?.MRP_price,
              parseInt(product?.skuDetails[0]?.NDP_Price),
              product?.GST
            )
          ) >= parseInt(allfilter?.dealerMargin);
        const minPriceFilterPassed =
          allfilter?.minPrice === 0 ||
          parseInt(product?.skuDetails[0]?.NDP_Price) >=
            parseInt(allfilter?.minPrice);
        const maxPriceFilterPassed =
          allfilter?.maxPrice === 0 ||
          parseInt(product?.skuDetails[0]?.NDP_Price) <=
            parseInt(allfilter?.maxPrice);

        // Check if the product has the specified badge (excluding ".png" extension)
        const badgeFilterPassed =
          allfilter?.shopByOffer === "" ||
          (product?.Badges && product?.Badges.replace(".png", "")) ===
            allfilter?.shopByOffer;

        return (
          brandFilterPassed &&
          outOfStockFilterPassed &&
          materialFilterPassed &&
          ageFilterPassed &&
          heightFilterPassed &&
          frameMaterialFilterPassed &&
          wheelSizeFilterPassed &&
          brakeTypeFilterPassed &&
          shippingFilterPassed &&
          ratingFilterPassed &&
          dealerMarginFilterPassed &&
          minPriceFilterPassed &&
          maxPriceFilterPassed &&
          badgeFilterPassed
        );
      });

      let sortedItems = [...filteredItems];

      if (allfilter?.sortPrice === "desc") {
        sortedItems?.sort(
          (a, b) =>
            parseInt(b?.skuDetails[0]?.NDP_Price) -
            parseInt(a?.skuDetails[0]?.NDP_Price)
        );
      } else if (allfilter.sortPrice === "asc") {
        sortedItems?.sort(
          (a, b) =>
            parseInt(a?.skuDetails[0]?.NDP_Price) -
            parseInt(b?.skuDetails[0]?.NDP_Price)
        );
      } else if (allfilter?.sortRating === "desc") {
        sortedItems.sort((a, b) => b?.net_rating - a?.net_rating);
      } else if (allfilter?.sortRating === "asc") {
        sortedItems.sort((a, b) => a?.net_rating - b?.net_rating);
      }

      setItems(sortedItems);
    } else {
      return;
    }
  }, [products, allfilter]);

  const handleLoginOverlay = (e) => {
    toggleOverlay();
    e.preventDefault();
  };

  // TO ADD PRODUCT INTO WISHLIST
  const handleAddToWishlist = async (data, e) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: data?.prod_ID,
    };
    dispatch(addToWishlistsAsync(wishlistData)).then(() =>
      dispatch(fetchAllWishlistsAsync(userDetail?.UserID)).then(() => {
        handleClose();
      })
    ); // Fetch updated wishlist
    e.preventDefault();
  };

  const handleRemoveFromWishlist = async (data, e) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: data?.prod_ID,
    };
    dispatch(removeFromWishlistAsync(wishlistData)).then(() => {
      dispatch(fetchAllWishlistsAsync(userDetail?.UserID)).then(() => {
        handleClose();
      });
    });
    e.preventDefault();
  };

  // PAGINATION
  const onPageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  useEffect(() => {
    setCurrentItems(
      Array.isArray(items) ? items.slice(indexOfFirstItem, indexOfLastItem) : []
    );
  }, [items, indexOfFirstItem, indexOfLastItem]);

  // Function to check if a product is in the wishlist
  const isInWishlist = (productId) => {
    return (
      Array.isArray(wishlist && wishlist?.product) &&
      wishlist?.product?.some((item) => item?.prod_ID === productId)
    );
  };

  const isOutOfStock = (productId) => {
    // Check if qtys is defined before destructuring
    if (!qtys) {
      // Handle the case where qtys is undefined
      return true; // Or any other logic you want when qtys is undefined
    }

    // Destructure CCQuantity from qtys if qtys is defined
    const { CCQuantity } = qtys;

    // Flatten the nested arrays into a single array of product objects
    const allProducts = CCQuantity?.flat();

    // Filter products matching the given productId
    const matchingProducts = allProducts?.filter(
      (product) => product?.prod_ID === productId
    );

    // If no matching products are found, return true (considered out of stock)
    if (matchingProducts?.length === 0) {
      return true;
    }

    // Check if all matching products have qty of 0
    return matchingProducts?.every((product) => product?.qty === 0);
  };

  const handleNavigate = (prod_id, event) => {
    event.preventDefault();
    navigate(`/product/${prod_id}`);
    // Analytics
    trackEvent({
      action: EVENTS.VIEW_PRODUCT,
      category: "Product",
      label: `User Visited Product ${prod_id}`,
      value: userDetail?.PhoneNumber
    });
  };

  const handleOpenDesktopVariant = (id, e) => {
    setOpenDesktopVariant(id);
    e.preventDefault();
  };

  const handleMouseEnter = () => {
    return;
  };

  const handleMouseLeave = () => {
    return;
  };


  return (
    <div className="w-full min-h-full h-full flex flex-col items-start justify-between">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open || filtering} // Show backdrop when either open or filtering state is true
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <div className="products-header-filter-container">
        <ListingHeader />
      </div> */}
      <div className="w-full min-h-[80%] bg-[#f3f3f3]">
        {currentItems && currentItems.length <= 0 && (
          <div className="w-full h-full flex items-center justify-center">
            <NoProductFound />
          </div>
        )}
        {currentItems && currentItems.length > 0 && (
          <div className="products-main-product-list-main-container">
            {currentItems.map((data) => (
              <div className="products-list-card-container" key={data?.prod_ID}>
                {data?.manufacture_name !== "ESI" && (
                  <div className="products-list-card-favourite-container">
                    {isInWishlist(data.prod_ID) ? (
                      <img
                        loading="lazy"
                        src={cartFilledLogo}
                        alt=""
                        onClick={(e) => {
                          handleRemoveFromWishlist(data, e);
                        }}
                        id="product-list-card-favourite-svg"
                      />
                    ) : (
                      <img
                        loading="lazy"
                        src={cartOutlineLogo}
                        alt=""
                        onClick={(e) => {
                          userDetail && userDetail?.UserID
                            ? handleAddToWishlist(data, e)
                            : handleLoginOverlay(e);
                        }}
                        id="product-list-card-favourite-svg"
                      />
                    )}
                  </div>
                )}
                <div
                  className="w-full h-[265px] overflow-hidden"
                  onClick={(event) => {
                    handleNavigate(data.prod_ID, event);
                  }}
                >
                  <HoverSlider images={data?.images && data.images} />
                </div>
                <div className="w-full h-auto flex flex-col justify-start relative pt-[10px] pr-[8px] pb-0 pl-[10px]">
                  <div className="products-list-card-product-ratings-container">
                    <span className="products-list-card-product-rating">
                      {parseInt(data.net_rating).toFixed(1)}
                    </span>
                    <StarIcon id="product-list-card-star-svg" />
                    <span className="products-list-card-product-rating-divider">
                      |
                    </span>
                    <span className="products-list-card-product-no-of-rating">
                      313
                    </span>
                  </div>
                  <div className="absolute right-[15px] top-[-10px] opacity-100 transition-all duration-200">
                    {isOutOfStock(data.prod_ID) ? (
                      <span className="text-peach text-[14px] font-bold">
                        Out of Stock
                      </span>
                    ) : (
                      <ShoppingCartOutlinedIcon
                        onClick={(e) => {
                          userDetail && userDetail?.UserID
                            ? handleOpenDesktopVariant(data.prod_ID, e)
                            : handleLoginOverlay(e);
                        }}
                        className=" text-white-1 bg-green rounded-[2px] p-[2px]"
                        style={{ fontSize: "20px" }}
                      />
                    )}
                  </div>
                  {data && data?.manufacture_images ? (
                    <img
                      loading="lazy"
                      className="w-[80px] h-[35px] object-contain"
                      src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_MANUFACTURE_IMAGE/${
                        data && data?.manufacture_images
                      }`}
                      alt=""
                    />
                  ) : (
                    <span className="h-[35px] text-[12px] italic font-bold">
                      {data.manufacture_name && data.manufacture_name}
                    </span>
                  )}
                  <div className="w-auto min-h-[40px] flex items-center justify-start">
                    <span className="text-[13px] font-bold m-0 text-blue capitalize tracking-wide line-clamp-2">
                      {data && (
                        <>
                          {data?.prod_name + ", " || ""}
                          {data?.product_Tech?.map((tech) => tech).join(" ")}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="w-full h-auto flex flex-col items-start justify-start relative pb-3">
                    <div className="flex items-center justify-center">
                      {data &&
                        data?.skuDetails &&
                        data?.skuDetails?.length > 0 &&
                        data?.skuDetails[0]?.NDP_Price && (
                          <>
                            <span className="text-[15px] font-bold capitalize text-[rgba(0,0,0,0.8)]">
                              Sale Price -{" "}
                              <b>
                                ₹
                                {formatWithCommasWithDecimal(
                                  calculateDealerPrice(
                                    parseInt(data.skuDetails[0].MRP_price),
                                    parseInt(data.skuDetails[0].NDP_Price),
                                    data?.GST
                                  )
                                )}
                              </b>
                            </span>
                          </>
                        )}
                    </div>
                    <div className="text-sm text-gray-600 flex items-center mt-1">
                      {data?.skuDetails?.length > 0 &&
                        data?.skuDetails[0]?.MRP_price && (
                          <span className="block text-gray-500 text-xs font-medium tracking-wide">
                            MRP - ₹
                            {formatWithCommasWithDecimal(
                              parseInt(data.skuDetails[0].MRP_price)
                            )}
                          </span>
                        )}

                      {calculateUpdatedDiscountPercentage(
                        data?.skuDetails[0]?.MRP_price,
                        data?.skuDetails[0]?.NDP_Price,
                        data?.GST
                      ) >= 1 && (
                        <div className="flex items-center gap-1 ml-4">
                          <span className="text-red-500 text-xs">
                            {calculateUpdatedDiscountPercentage(
                              data?.skuDetails[0]?.MRP_price,
                              parseInt(data.skuDetails[0].NDP_Price),
                              data?.GST
                            )}
                            % off
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* </Carousel> */}
        {openDesktopVariant !== null && (
          <SelectDesktopVariant
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            openDesktopVariant={openDesktopVariant}
            setOpenDesktopVariant={setOpenDesktopVariant}
            product={products?.product.find(
              (item) => item.prod_ID === openDesktopVariant
            )}
            qtys={qtys}
          />
        )}
      </div>
      <div className="products-main-paginations-container">
        {currentItems && currentItems.length > 0 && (
          <ListingPagination
            totalItems={items && items.length}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
     
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});
const mapDispatchToProps = {
  toggleOverlay,
};
export default connect(mapStateToProps, mapDispatchToProps)(Product);
